import { Navigate } from 'react-router-dom';
import { useContractorAuthStore } from '../lib/contractorAuth';

interface Props {
  children: React.ReactNode;
}

export function ContractorProtectedRoute({ children }: Props) {
  const contractor = useContractorAuthStore((s) => s.contractor);
  const initialized = useContractorAuthStore((s) => s.initialized);

  if (!initialized) {
    return (
      <div style={{
        minHeight: '100dvh', display: 'flex',
        alignItems: 'center', justifyContent: 'center',
      }}>
        <div style={{
          width: 32, height: 32, border: '3px solid #e5e7eb',
          borderTopColor: '#1D4ED8', borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }} />
      </div>
    );
  }

  if (!contractor) {
    return <Navigate to="/contractor/login" replace />;
  }

  return <>{children}</>;
}
